// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackSquareFilledSvg from "@fishx/icons-svg/es/asn/SlackSquareFilled";
import FishxIcon from '../components/FishxIcon';

var SlackSquareFilled = function SlackSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareFilledSvg
  }));
};

SlackSquareFilled.displayName = 'SlackSquareFilled';
export default React.forwardRef(SlackSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SlackSquareFilled.js
// module id = 4146
// module chunks = 0